export default {
    methods: {
        determineLanguage(values= Object) {
            if (typeof values == 'object') {
                let lang = this.language;
                return values[lang];
            } else {
                console.error('Input is not an object, some translations will not show');
            }
        }
    }
};